<template>
  <div>
    <svg
      id="grapView"
      width="600"
      height="350"
    >
      <g style="transform: translate(80px, 10px)">
        <path
          :d="calculatedBaselinePath"
          class="baselinePath"
        />
      </g>
      <g style="transform: translate(80px, 10px)">
        <path
          :d="calculatedPath"
          class="path"
        />
      </g>
      <g
        id="axisLeft"
        style="transform: translate(80px, 10px)"
      />
      <g
        id="axisBottom"
        style="transform: translate(80px, 260px)"
      />

      <g
        class="label"
        transform="rotate(-90 80 80)"
      >
        <text
          x="20"
          y="20"
          text-anchor="middle"
        >{{ legend }}</text>
      </g>
      <g
        class="label"
        transform="translate(260, 285)"
      >
        <text
          x="40"
          y="14"
        >Time</text>
      </g>

      <g
        class="legend"
        transform="translate(135, 320)"
      >
        <rect
          width="18"
          height="6"
          style="fill: #f18b23;"
        />
        <text
          x="22"
          y="7"
        >{{ savedRunName || "With your choices" }}</text>
      </g>
      <g
        class="legend"
        transform="translate(135, 340)"
      >
        <rect
          width="18"
          height="6"
          style="fill: #c1c1c1;"
        />
        <text
          x="22"
          y="7"
        >{{ baselineName === "Baseline" ? "Without your choices" : baselineName }}</text>
      </g>
    </svg>
  </div>
</template>

<script>
import * as d3 from "d3";
import numeral from "numeral";

export default {
  props: {
    data: {
      type: Array,
      required: false,
      default: () => []
    },
    baseline: {
      type: Array,
      required: false,
      default: () => []
    },
    currentStep: {
      type: Number,
      required: false,
      default: 0
    },
    savedRunName: {
      type: String,
      required: false,
      default: null
    },
    baselineName: {
      type: String,
      required: false,
      default: ""
    },
    legend: {
      type: String,
      required: false,
      default: ""
    },
    target: {
      type: Array,
      required: false,
      default: () => []
    },
    format: {
      type: String,
      default: "0,0"
    }
  },
  data() {
    return {
      calculatedPath: "",
      calculatedBaselinePath: ""
    };
  },
  watch: {
    data() {
      this.calculatePaths();
    }
  },
  mounted() {
    this.calculatePaths();
  },
  updated() {
    this.calculatePaths();
  },
  methods: {
    getScales() {
      const width = 480;
      const height = 250;

      // const data = this.data.slice(0, Math.min(this.data.length, this.currentStep));
      const data = this.data;

      const yTicksMax = data.length - 1;
      const yVisibleTicksMax = 12;

      const indexes = [];
      for (let i = 0; i <= yTicksMax; i++) {
        indexes.push(i);
      }

      const x = d3.scaleLinear().range([0, width]);
      const y = d3.scaleLinear().range([height, 0]);

      x.domain(d3.extent(indexes, d => d));
      y.domain([
        d3.min(data, d => d * 0.8),
        d3.max(data, d => d * 1.2)
        ]);

      const tickValues = [];
      const stepSize = Math.max(Math.ceil(yTicksMax / yVisibleTicksMax), 1);

      for (let i = 1; i <= yTicksMax; i += stepSize) {
        tickValues.push(i);
      }

      d3.select("#axisBottom").call(
        d3
          .axisBottom()
          .scale(x)
          .tickValues(tickValues)
          .tickFormat(function(d) {
            const year = parseInt(d);
            // Every second tick is "labelless"
            if (year % 2 === 1) {
              return '';
            }
            return `y${Math.round(year)}`;
          })
      );

      const format = this.format;

      d3.select("#axisLeft").call(
        d3
          .axisLeft()
          .scale(y)
          .ticks(10)
          .tickFormat(function(d) {
            return numeral(d).format(format);
          })
      );

      return { x, y };
    },
    calculatePaths() {
      const scale = this.getScales();
      const path = d3
        .line()
        .x((d, i) => scale.x(i))
        .y(d => scale.y(d));
      this.calculatedPath = path(this.data);

      const baselinePath = d3
        .line()
        .x((d, i) => scale.x(i))
        .y(d => scale.y(d));

      if (this.baseline) {
        this.calculatedBaselinePath = baselinePath(
          this.baseline.slice(0, Math.min(this.data.length, this.currentStep))
        );
      }
    }
  }
};
</script>

<style lang="scss">
svg {
  margin: 25px;
}
svg .path {
  fill: none;
  stroke: #f18b23;
  stroke-width: 2px;
}
svg .baselinePath {
  fill: none;
  stroke: #ccc;
  stroke-width: 1px;
}
svg .targetPath {
  fill: none;
  stroke: #999;
  stroke-width: 1px;
  stroke-dasharray: 2px;
}
svg .axis {
  fill: none;
  stroke: #000;
  stroke-width: 10px;
}
</style>
